import { render, staticRenderFns } from "./attrFrom.vue?vue&type=template&id=264d3a59&scoped=true"
import script from "./attrFrom.vue?vue&type=script&lang=js"
export * from "./attrFrom.vue?vue&type=script&lang=js"
import style0 from "./attrFrom.vue?vue&type=style&index=0&id=264d3a59&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "264d3a59",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/www/git_project/hys_supply_chain/mer/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('264d3a59')) {
      api.createRecord('264d3a59', component.options)
    } else {
      api.reload('264d3a59', component.options)
    }
    module.hot.accept("./attrFrom.vue?vue&type=template&id=264d3a59&scoped=true", function () {
      api.rerender('264d3a59', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/base/attrFrom.vue"
export default component.exports